<div
  [ngClass]="{
    'igo-spinner-container': true,
    'igo-spinner-shown': (shown$ | async)
  }"
>
  <div class="igo-spinner-background"></div>
  <mat-progress-spinner diameter="40" mode="indeterminate" />
</div>
